import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import ScatterPlot from '../diagrams/Scatterplot'
import BarChartPlot from '../diagrams/Barchart'
import endpoints from '../endpoints.json'
import './Analyze.css'

const Analyze = () => {
  const [data, setData] = useState([])
  const [info, setInfo] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await window.PDR.api.get(`${endpoints[window.location.host]}/analyze`)
        console.log(response)
        console.log(response)
        setData(response.pca_data) // Assuming `setData` is defined elsewhere!
        setInfo(response.cluster_data) // Assuming `setInfo` is defined elsewhere
      } catch (error) {
        console.error('There was an error fetching the data:', error)
      }
    }

    fetchData()
  }, [])

  return (
    <div>
      <div className="header">
        {/* Icon and title in the upper right corner */}
        <img
          className="stratsys-search-logo"
          src="https://frontend-packages.svc.stratsys.com/logos/icon-dark.svg"
          alt="Stratsys Icon"
        />
        <div class="one-ux-typography--heading-500">
          <one-ux-text>Support Analysis</one-ux-text>
        </div>
      </div>

      <div>
        <ScatterPlot data={data} />
      </div>
      <div>
        {info.map((ini, index) => (
          <div key={index}>
            <h2>{ini.title}</h2>
            <p>{ini.description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Analyze
